module.exports = __webpack_public_path__ + "img/2.d6df7537.jpg";